const jobListColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "File Name",
    accessor: "file_name",
  },
  {
    Header: "Job Name",
    accessor: "job_name",
  },
  {
    Header: "Interface Type",
    accessor: "interface_type",
  },
  {
    Header: "File Processing Date Time",
    accessor: "file_processing_date_time",
  },
  {
    Header: "File Completion Date Time",
    accessor: "file_completion_date_time",
  },
  {
    Header: "No Of Rows Read",
    accessor: "no_of_rows_read",
  },
  {
    Header: "No Of Rows Processed",
    accessor: "no_of_rows_processed",
  },
  {
    Header: "No Of Rows Rejected",
    accessor: "no_of_rows_rejected",
  },
  // {
  //   Header: "S3 Po Path",
  //   accessor: "s3_po_path",
  // },
  {
    Header: "Compared File Name",
    accessor: "compared_file_name",
  },
  {
    Header: "IS File Identical",
    accessor: "is_file_identical",
  },
  {
    Header: "Created at",
    accessor: "created_at",
  },
];

export default jobListColumns;
